<script setup lang="ts">
import styles from '@/assets/sass/components/cruise-alternative.module.scss';
import { LANGUAGE } from '@/env';
import formatDate from '@/utilities/formatDate';
import formatPrice from '@/utilities/formatPrice';
import type { Price } from '@/utilities/price';

interface Props {
    cruiseCode: string;
    departureDate: Date;
    price: Price;
}

const props = defineProps<Props>();

</script>
<template>
    <div :class="styles['cruise-alternative']">
        <div :class="styles['cruise-alternative__date']">
            {{ formatDate(departureDate) }}
        </div>
        <div :class="styles['cruise-alternative__price']">
            {{ $t('LABELS.from') }} {{ formatPrice(price.getCurrencyDetails(LANGUAGE)?.amount_decimal) }} {{
                price.getCurrencyDetails(LANGUAGE)?.currency }}
        </div>
        <RouterLink :class="styles['cruise-alternative__choose-btn']" :to="{
            name: 'cruiseReservationPackage',
            params: {
                cruise_code: cruiseCode
            }
        }">
            {{ $t('LABELS.choose-cabin') }}
        </RouterLink>
    </div>
</template>
